document.addEventListener('DOMContentLoaded', () => {
  const el      = document.querySelector('#policy-banner, #cookie-banner');
  const modal   = document.querySelector('#policy-modal, #cookie-modal');
  const overlay = document.getElementById('cookie-modal-overlay');
  const btnClose = document.getElementById('cookie-modal-close');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;
  let closeTimer = null;
  const btnAccept  = document.getElementById('accept-cookies');
  const btnDecline = document.getElementById('decline-cookies');
  const btnPrefs   = document.getElementById('cookie-settings');
  const btnSave    = document.getElementById('save-settings');
  const chkAnalytics = document.getElementById('analytics-consent');

  if (!el) return;

  const safeStorage = (() => {
    try {
      const k = '__tst__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return window.localStorage;
    } catch (e) {
      const mem = {};
      return {
        getItem: (k) => (k in mem ? mem[k] : null),
        setItem: (k, v) => { mem[k] = String(v); },
        removeItem: (k) => { delete mem[k]; }
      };
    }
  })();

  const CFG = {
    VERSION: '1',
    KEY_CONSENT: 'cookieConsent',
    KEY_ANALYTICS: 'analyticsConsent',
    KEY_VERSION: 'cookieConsentVersion'
  };

  const hasDecision = () => !!safeStorage.getItem(CFG.KEY_CONSENT);
  const getAnalyticsAllowed = () => safeStorage.getItem(CFG.KEY_ANALYTICS) === 'true';

  const showBar = () => el.classList.add('is-visible');
  const hideBar = () => el.classList.remove('is-visible');

  const isModalOpen = () => !!overlay && overlay.classList.contains('is-open');

  const showModal = () => {
    if (!modal || !overlay || isModalOpen()) return;
    clearTimeout(closeTimer);
    const saved = safeStorage.getItem(CFG.KEY_ANALYTICS);
    if (chkAnalytics && saved !== null) chkAnalytics.checked = saved === 'true';
    lastFocused = document.activeElement;
    overlay.hidden = false;
    overlay.classList.remove('is-closing');
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    (chkAnalytics || modal).focus();
  };

  const hideModal = ({ restoreFocus = true } = {}) => {
    if (!overlay || !isModalOpen()) return;
    overlay.classList.remove('is-open');
    overlay.classList.add('is-closing');
    document.documentElement.style.overflow = '';
    closeTimer = setTimeout(() => {
      overlay.classList.remove('is-closing');
      overlay.hidden = true;
    }, 360);
    let target = restoreFocus ? lastFocused : null;
    // If the opener is gone (e.g. banner hidden after saving), fall back to main content.
    if (!target || !document.contains(target) || target.closest('[hidden]') || !target.offsetParent) {
      target = document.getElementById('MainContent') || document.body;
      if (target !== document.body && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    }
    target.focus?.({ preventScroll: true });
    lastFocused = null;
  };

  const trapFocus = (e) => {
    if (e.key !== 'Tab' || !isModalOpen()) return;
    const items = Array.from(modal.querySelectorAll(FOCUSABLE)).filter((n) => n.offsetParent !== null);
    if (!items.length) { e.preventDefault(); modal.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === modal)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  };

  const applyConsent = (allowed) => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: allowed ? 'granted' : 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      });
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'cookie_consent_update', analytics_allowed: !!allowed });
    }
  };

  const persist = ({ consent, analytics }) => {
    safeStorage.setItem(CFG.KEY_CONSENT, consent);
    safeStorage.setItem(CFG.KEY_ANALYTICS, analytics ? 'true' : 'false');
    safeStorage.setItem(CFG.KEY_VERSION, CFG.VERSION);
    applyConsent(!!analytics);
    window.dispatchEvent(new CustomEvent('cookieconsentchange', { detail: { consent, analytics: !!analytics }}));
  };

  const needsReconsent = safeStorage.getItem(CFG.KEY_VERSION) !== CFG.VERSION;
  const debug   = new URLSearchParams(location.search).has('cookieDebug');
  const forced  = el.dataset.force === 'true';

  if (forced || debug || needsReconsent || !hasDecision()) {
    setTimeout(showBar, 50);
  } else {
    applyConsent(getAnalyticsAllowed());
  }

  btnAccept?.addEventListener('click', () => { persist({ consent: 'accepted', analytics: true }); hideBar(); });
  btnDecline?.addEventListener('click', () => { persist({ consent: 'declined', analytics: false }); hideBar(); });
  btnPrefs?.addEventListener('click', showModal);
  btnSave?.addEventListener('click', () => {
    const allowed = !!chkAnalytics?.checked;
    persist({ consent: 'custom', analytics: allowed });
    hideBar(); hideModal();
  });
  btnClose?.addEventListener('click', () => hideModal());
  overlay?.addEventListener('click', (e) => { if (e.target === overlay) hideModal(); });
  document.addEventListener('keydown', (e) => {
    if (!isModalOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); hideModal(); return; }
    trapFocus(e);
  });
  // Keep focus inside the dialog if it escapes (e.g. via pointer or AT navigation).
  document.addEventListener('focusin', (e) => {
    if (isModalOpen() && !modal.contains(e.target)) modal.focus();
  });

  window.CookieConsent = {
    open: () => showModal(),
    reset: () => {
      safeStorage.removeItem(CFG.KEY_CONSENT);
      safeStorage.removeItem(CFG.KEY_ANALYTICS);
      safeStorage.removeItem(CFG.KEY_VERSION);
      showBar();
    },
    state: () => ({
      consent: safeStorage.getItem(CFG.KEY_CONSENT),
      analytics: safeStorage.getItem(CFG.KEY_ANALYTICS),
      version: safeStorage.getItem(CFG.KEY_VERSION)
    })
  };
});
